"use strict";function getUserExclusiveInfo$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.getUserExclusiveInfo$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.realm.getUserExclusiveInfo";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"6.0.14"},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.0.14"},_a[ddSdk_1.ENV_ENUM.pc]={vs:"6.0.17"},_a)),exports.getUserExclusiveInfo$=getUserExclusiveInfo$,exports.default=getUserExclusiveInfo$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/realm/getUserExclusiveInfo.js
// module id = 984
// module chunks = 106